import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Cuts at the first line break within a comment or maxLength, whichever comes first
export function truncateText(text: string, maxLength: number): string {
  const newlineIndex = text.indexOf("\n");
  if (newlineIndex !== -1 && newlineIndex <= maxLength) {
    return `${text.slice(0, newlineIndex)}…`;
  }
  return text.length > maxLength ? `${text.slice(0, maxLength)}…` : text;
}

export function isUserTyping(): boolean {
  const active = document.activeElement;
  return (
    active instanceof HTMLInputElement ||
    active instanceof HTMLTextAreaElement ||
    (active instanceof HTMLElement && active.isContentEditable)
  );
}
